import React from 'react';

const CloudProviders = () => {
  const providers = [
    {
      id: 1,
      name: 'AWS',
      target: 'Hetzner',
      logo: '../assets/images/migration/aws-logo-bbde8644fb813e350642eeca4ccbbb8c.png',
      gradient: 'from-orange-500 to-yellow-500',
      savings: '98%',
      description: 'Struggling with high cloud costs and complex pricing? We migrate your servers, databases, storage, and applications to Hetzner while reducing expenses and maintaining performance, security, and reliability.',
      link: '/aws-to-hetzner-migration'
    },
    {
      id: 2,
      name: 'Azure',
      target: 'Hetzner',
      logo: '../assets/images/migration/azure-logo-128e2443446487b0e0130921c8c46662.png',
      gradient: 'from-blue-500 to-cyan-500',
      savings: '95%',
      description: 'Azure virtual machines, databases, storage, web applications, and serverless workloads – we migrate your infrastructure to Hetzner with a focus on lower costs, improved flexibility, and reliable performance.',
      link: '/azure-to-hetzner-migration'
    },
    {
      id: 3,
      name: 'Google Cloud',
      target: 'Hetzner',
      logo: '../assets/images/migration/gcp-logo-abd3ce0748e83ff6e50c8074962dd13a.png',
      gradient: 'from-red-500 to-yellow-500',
      savings: '95%',
      description: 'Compute, databases, storage, containers, and cloud-native services – we redesign and migrate your GCP environment to Hetzner for a simpler, more cost-efficient infrastructure.',
      link: '/google-cloud-to-hetzner'
    },
    {
      id: 4,
      name: 'DigitalOcean',
      target: 'Hetzner',
      logo: '../assets/images/migration/do.png',
      gradient: 'from-blue-600 to-blue-400',
      savings: '70%',
      description: 'Droplets, managed databases, object storage, and application platforms – we move your DigitalOcean workloads to Hetzner to reduce operating costs while maintaining security and scalability.',
      link: '/digitalocean-to-hetzner-cloud-migration'
    },
  ];

  // Arrow Icon Component
  const ArrowIcon = () => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      aria-hidden="true" 
      data-slot="icon" 
      className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" 
      />
    </svg>
  );

  return (
    <section id="providers" className="py-5 transition-all duration-700 opacity-100 translate-y-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Select Your Current Platform
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Choose your existing infrastructure or cloud provider to explore available migration and modernization options.
          </p>
        </div>
        
        {/* Providers Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          
          {providers.map((provider) => (
            <a
              key={provider.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-blue-200"
              href={provider.link}
            >
              {/* Gradient Header */}
              <div className={`bg-gradient-to-r ${provider.gradient} p-6`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="bg-white rounded-xl p-3 shadow-md">
                      <img 
                        src={provider.logo} 
                        alt={provider.name} 
                        className="h-10 w-10 object-contain"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white">
                        {provider.name} to {provider.target}
                      </h3>
                      <p className="text-white/80 text-sm">Migration</p>
                    </div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                    <span className="text-white font-bold text-lg">
                      -{provider.savings}
                    </span>
                  </div>
                </div>
              </div>
              
              {/* Content Body */}
              <div className="p-6">
                <p className="text-gray-600 mb-4">
                  {provider.description}
                </p>
                <div className="flex items-center text-blue-600 font-medium group-hover:text-blue-700">
                  <span>Learn more</span>
                  <ArrowIcon />
                </div>
              </div>
            </a>
          ))}
          
        </div>
        
        {/* Note Section */}
        <div className="max-w-4xl mx-auto mt-10">
          <div className="p-4 rounded-lg border border-gray-200 bg-gray-50 text-gray-600" role="note">
            <p className="text-xs leading-relaxed">
              <strong>Pricing & Savings Disclaimer:</strong>
Cost estimates, pricing information, and potential savings mentioned on this website are provided for general informational purposes only. Actual costs and savings may vary based on your infrastructure, resource usage, configuration, and the pricing policies of the respective cloud providers. We recommend reviewing the latest pricing and service terms directly with the relevant provider before making any decisions.
            </p>
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default CloudProviders;